import React from 'react';
import { useViewerCount } from '../hooks/useViewerCount';
type ViewerCounterProps = {
  className?: string;
};
export function ViewerCounter({
  className = ''
}: ViewerCounterProps) {
  const count = useViewerCount();
  return <div className={`flex items-center justify-center gap-2 rounded-full border-b border-gold/40 bg-forest px-4 py-2.5 ${className}`} aria-live="polite" data-id="element-148" data-mp="35x31vrtkna9z">
      <span aria-hidden="true" className="h-2 w-2 rounded-full bg-green-500 animate-dot-pulse" data-id="element-149" data-mp="2d9gxwigfm3ml" />
      <p className="font-sans text-[14px] font-medium text-gold" data-id="element-150" data-mp="28anfqcq79og3">
        {count} personas viendo esto ahora
      </p>
    </div>;
}